(function () {
  var BACK_HASHES = {
    quartz: '795c2995fad54aa5',
    iris: '27f3d8d5f1af4d3fb',
    sage: '470db0dd40f14f5f'
  };

  function labelText(label) {
    var clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .label-unavailable').forEach(function (el) {
      el.remove();
    });
    return clone.textContent.trim().toLowerCase();
  }

  function currentColor(root) {
    var fieldset = Array.prototype.find.call(root.querySelectorAll('fieldset'), function (fs) {
      var legend = fs.querySelector('legend');
      return legend && legend.textContent.trim().toLowerCase() === 'color';
    });
    if (!fieldset) return null;
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    if (!checked) return null;
    var label = fieldset.querySelector('label[for="' + checked.id + '"]');
    return label ? labelText(label) : null;
  }

  function apply(productInfo) {
    var list = productInfo.querySelector('.product__media-list');
    if (!list) return;

    var color = currentColor(productInfo);
    var hash = color && BACK_HASHES[color];
    if (!hash) return;

    var items = Array.prototype.slice.call(list.children);
    var backLi = items.find(function (li) {
      var img = li.querySelector('img');
      var src = img && (img.currentSrc || img.src || '');
      return src && src.indexOf(hash) !== -1;
    });
    if (!backLi) return;

    var activeLi = list.querySelector('.product__media-item.is-active') || items[0];
    if (!activeLi || activeLi === backLi) return;

    backLi.dataset.wmBackHash = hash;
    activeLi.dataset.wmFrontPair = hash;
    if (activeLi.nextElementSibling !== backLi) {
      activeLi.parentNode.insertBefore(backLi, activeLi.nextElementSibling);
    }
  }

  function init(root) {
    (root || document).querySelectorAll('product-info').forEach(apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      var sectionId = evt && evt.data && evt.data.sectionId;
      var productInfo = sectionId
        ? document.querySelector('product-info[data-section="' + sectionId + '"]')
        : null;
      if (productInfo) {
        apply(productInfo);
      } else {
        init();
      }
    });
  }
})();
